import { StripeSubscriptionStatus } from './stripe';

export enum SubscriptionBillingPeriod {
  Monthly = 'monthly',
  Annual = 'annual',
}

export enum SubscriptionTier {
  Pro = 'pro',
  Team = 'team',
}

export enum SubscriptionTrialIneligibilityReason {
  TrialConsumed = 'trial_consumed',
  JoinedTeamFirst = 'joined_team_first',
  TeamOwner = 'team_owner',
}

export type Subscription = {
  status: StripeSubscriptionStatus;
  tier: SubscriptionTier;
  billing_period: SubscriptionBillingPeriod;
  trial_end: string | null;
  current_period_end: string | null;
  cancel_at_period_end?: boolean;
  canceled_at?: string | null;
  seats?: number | null;
  error?: string;
};
